import { render } from "./ElSelectExt.vue?vue&type=template&id=22fb3db9&scoped=true&ts=true"
import script from "./ElSelectExt.vue?vue&type=script&lang=ts"
export * from "./ElSelectExt.vue?vue&type=script&lang=ts"

import "./ElSelectExt.vue?vue&type=style&index=0&id=22fb3db9&scoped=true&lang=css"

import exportComponent from "E:\\twl\\workspace\\auxiliary-ts-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fb3db9"]])

export default __exports__